import { render, staticRenderFns } from "./NavUserCenterFavorite.vue?vue&type=template&id=64b63b5f&scoped=true&"
import script from "./NavUserCenterFavorite.vue?vue&type=script&lang=js&"
export * from "./NavUserCenterFavorite.vue?vue&type=script&lang=js&"
import style0 from "./NavUserCenterFavorite.vue?vue&type=style&index=0&id=64b63b5f&lang=less&scoped=true&"
import style1 from "./NavUserCenterFavorite.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b63b5f",
  null
  
)

export default component.exports